module.exports = __webpack_public_path__ + "img/acv2.653a5a96.png";